/*
  Second Spring: open the cart drawer after add-to-cart calls made by apps (for example Kaching Bundles).
  The theme's own product form already opens the drawer; it sends a "sections" field, so those calls are skipped here.
*/
(function () {
  if (window.__ssCartOpen) return;
  window.__ssCartOpen = true;

  let timer = null;
  function openDrawer() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer();
    }, 150);
  }

  function isAppAdd(url, body) {
    if (!url || String(url).indexOf('/cart/add') === -1) return false;
    if (body instanceof FormData) return !body.has('sections');
    if (typeof body === 'string') return body.indexOf('sections') === -1;
    return true;
  }

  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    const appAdd = isAppAdd(url, init && init.body);
    return nativeFetch.apply(this, arguments).then(function (res) {
      if (appAdd && res.ok) openDrawer();
      return res;
    });
  };

  const open = XMLHttpRequest.prototype.open;
  const send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ssUrl = url;
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (isAppAdd(this.__ssUrl, body)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) openDrawer();
      });
    }
    return send.apply(this, arguments);
  };
})();
